export default __webpack_public_path__ + "static/download_smartbak_app-ee0eaa7b0a76ba64d849244d413d572d.webp";